import { AHRISystemToolConfigState } from "@crescentParts/Store/Data/AHRISystemToolConfig/AHRISystemToolConfigState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialAHRISystemToolConfigState: AHRISystemToolConfigState = {
    attributeValueIds: [],
};

const reducer = {
    "Custom/AHRISystemToolConfig/PopulateAHRISystemToolConfigParam": (draft: Draft<AHRISystemToolConfigState>) => { },
    "Custom/AHRISystemToolConfig/CleanAHRISystemToolConfig": (draft: Draft<AHRISystemToolConfigState>) => {
        draft.attributeValueIds = [];
    },

    "Custom/AHRISystemToolConfig/SetAHRISystemToolConfig": (
        draft: Draft<AHRISystemToolConfigState>,
        action: { result: AHRISystemToolConfigState },
    ) => {
        draft.attributeValueIds = action.result.attributeValueIds;
    },
};

export default createTypedReducerWithImmer(initialAHRISystemToolConfigState, reducer);
